import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { EASE } from "../../lib/anim";

export const Accordion = ({ items, testid = "accordion" }) => {
  const [open, setOpen] = useState(null);
  return (
    <div className="border-t border-white/10" data-testid={testid}>
      {items.map((it, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className="border-b border-white/10">
            <button
              onClick={() => setOpen(isOpen ? null : i)}
              data-testid={`${testid}-trigger-${i}`}
              className="w-full flex items-start justify-between gap-8 py-8 text-left group"
            >
              <span className="display text-xl sm:text-2xl lg:text-3xl text-[#f5f3ee] group-hover:text-[#5CCBF5] transition-colors duration-300 max-w-3xl">
                {it.q}
              </span>
              <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.4, ease: EASE }} className="mt-2 text-[#a7a7a2] shrink-0">
                <Plus size={22} strokeWidth={1.2} />
              </motion.span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.5, ease: EASE }}
                  className="overflow-hidden"
                >
                  <p className="pb-9 pr-12 text-[#a7a7a2] text-lg leading-relaxed max-w-3xl">{it.a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
